module.exports = __webpack_public_path__ + "img/home-works-3.2f219b22.png";